export default __webpack_public_path__ + "static/media/Sunset-Turbines-Narrow-960px-360px.00acd785.jpg";